import { select } from 'redux-saga/effects';
import { normalizeTechnicalErrors } from '@bitComponents/telcovid/ErrorManagementUtils';

const getErrorManagement = state => state.errorManagement;

export function* normalizeHttpErrors(origin, error) {
  const {
    webServiceErrorHandler: specificWebServiceErrorHandler,
    handledErrors,
  } = yield select(getErrorManagement);

  const errorToPrint = normalizeTechnicalErrors(
    origin,
    error,
    specificWebServiceErrorHandler,
    handledErrors,
  );
  return errorToPrint;
}
